import template from './timezones.html';
import controller from './timezones.controller';
import './timezones.scss';

let timezonesComponent = {
  bindings: {
    timezones: '<',
    selected: '<',
    disabled: '<',
    onSelect: '&'
  },
  template,
  controller
};

export default timezonesComponent;



// WEBPACK FOOTER //
// ./src/app/components/timezones/timezones.component.js